import React from "react";
import { SERVICES_KEYS } from "shared/constants/services";
import { FormattedMessage } from "gatsby-plugin-intl";
import internationalTransferAnimation from "images/services/international.mp4";
import internationalTransferPartners from "images/services-partners/international-transfer.png";
import insuranceAnimation from "images/services/insurance.mp4";
import insurancePartners from "images/services-partners/insurance.png";
import billPaymentAnimation from "images/services/billPayment.mp4";
import billPaymentPartners from "images/services-partners/bill-payment.png";
import refillAnimation from "images/services/refill.mp4";
import refillPartners from "images/services-partners/refill.png";
import taxesAnimation from "images/services/taxes.mp4";
import taxesPartners from "images/services-partners/taxes.png";
import transportAnimation from "images/services/transport.mp4";
import transportPartners from "images/services-partners/transport.png";

// eslint-disable-next-line import/prefer-default-export
export const SERVICES_MODALS = {
  [SERVICES_KEYS.INTERNATIONAL_TRANSFER]: {
    title: (
      <FormattedMessage id="chaabiServices.internationalTransfer.modal.title" />
    ),
    animatedBannerSrc: internationalTransferAnimation,
    partnersSrc: internationalTransferPartners,
  },
  [SERVICES_KEYS.BILL_PAYMENT]: {
    title: <FormattedMessage id="chaabiServices.billPayment.modal.title" />,
    animatedBannerSrc: billPaymentAnimation,
    partnersSrc: billPaymentPartners,
  },
  [SERVICES_KEYS.INSURANCE_AND_CNSS]: {
    title: (
      <FormattedMessage id="chaabiServices.insuranceAndCNSS.modal.title" />
    ),
    animatedBannerSrc: insuranceAnimation,
    partnersSrc: insurancePartners,
  },
  [SERVICES_KEYS.TICKETING_AND_TRANSPORTATION]: {
    title: (
      <FormattedMessage id="chaabiServices.ticketingAndTransportation.modal.title" />
    ),
    animatedBannerSrc: transportAnimation,
    partnersSrc: transportPartners,
  },
  [SERVICES_KEYS.TAXES]: {
    title: <FormattedMessage id="chaabiServices.taxes.modal.title" />,
    animatedBannerSrc: taxesAnimation,
    partnersSrc: taxesPartners,
  },
  [SERVICES_KEYS.REFILL]: {
    title: <FormattedMessage id="chaabiServices.refill.modal.title" />,
    animatedBannerSrc: refillAnimation,
    partnersSrc: refillPartners,
  },
};
